function getRelativeValue(value, total, decimals) {
	if (total && value) {
		return (
			Math.round(
				((value * 100) / total + Number.EPSILON) * Math.pow(10, decimals)
			) / Math.pow(10, decimals)
		);
	} else {
		return 0;
	}
}

export default getRelativeValue;
